/**
 * 지난주 대비 증감 한 줄(`+12%` · `-3%`) — 상세 머리와 공유 페이지가 같은 말을 쓴다.
 * @param prev 직전 7일 — 0 이면 부르는 쪽이 아예 적지 않는다(나눌 수 없다)
 */
export function weekGrowthLabel(recent: number, prev: number): string {
  const rate = ((recent - prev) / prev) * 100;
  return `${rate >= 0 ? '+' : ''}${Math.round(rate)}%`;
}
